import React, { FC, useContext, useEffect, useState } from 'react'
import * as pageUtils from './__index.utils'
import { AppStateContext } from '@components/layouts/DynamicLayout'
import { joinClasses } from '@utils/styles'
import { Request, RequestConsent } from '@services/models'
import { getRequestName, MODAL } from '@pages/auth/requests/__[id].utils'
import HistoryCard from '../historyCard'
import { formatStrapiText } from '@utils/methods'
import Consent from '../consent'
import Notification from '@components/ui/notification'
import AddInformationModal from '../modals/addInformationModal'
import IncidentFormDetails from '../incidentFormDetails'
import Collapse from '../collapse'
import RedirectModal from '../modals/redirectModal'
import moment from 'moment'
import StatusBadge from './StatusBadge'
import RequestInfoSection from './RequestInfoSection'
import PaymentDueSection from './PaymentDueSection'
import PersonalInfoSection from './PersonalInfoSection'
import PaymentInfosSection from './PaymentInfosSection'
import { DOCUMENT_ENVOYE_FORM, DOSSIER_FORM } from './__index.utils'
import DocumentsEnvoyesSection from './DocumentsEnvoyesSection'
import { DossierStatusEnum } from '@services/constants/dossiers.constant'
import CancelDossierModal from '../modals/cancelDossierModal'
import CancelRequestModal from '../modals/cancelRequestModal'
import DocumentsEmisSection from './DocumentsEmisSection'
import PaymentRedirectModal from '../modals/paymentRedirectModal'
import { Icon } from '../Icon'
import { plusWhiteIcon } from '@images/icons'
import DisplayInforModal from '../modals/displayInfoModal'

type propsType = {
	activeTab: string
	isPrincipal: boolean
	dossier: DOSSIER_FORM | undefined
	documentsEnvoyes: DOCUMENT_ENVOYE_FORM[]
	multiDossier?: boolean
	request: Request
	isModalOpen: string
	consentList: RequestConsent[]
	consentClassWrapper: string
	onAddNewConsent: (consent: RequestConsent) => void
	onCloseModal: () => void
	onToggleModal: (value: string) => void
	onInformationAdded: (consentId: any) => void
	requeteDateRecu: string | undefined
	requeteStatut: string | undefined
	onRefreshRepere?: () => Promise<void>
}

type stateType = {
	isPaymentSuccessful?: boolean
	code?: string
	hasInvoice?: boolean
}

const DossierViewer: FC<propsType> = ({
	activeTab,
	isPrincipal,
	dossier,
	documentsEnvoyes,
	multiDossier,
	request: requestInfo,
	consentList,
	consentClassWrapper,
	onCloseModal,
	isModalOpen,
	onInformationAdded,
	onAddNewConsent,
	onToggleModal,
	requeteDateRecu,
	requeteStatut,
	onRefreshRepere
}) => {
	const state = window.history.state as stateType
	const [addDocumentsType, setAddDocumentsType] = useState<boolean>(false)
	const [redirect, setRedirect] = useState<boolean>(false)
	const { pageData, authUser, language } = useContext(AppStateContext)

	const [request, setRequest] = useState<Request>(requestInfo)
	const [addInformationSuccess, setAddInformationSuccess] =
		useState<boolean>(false)

	const excludedStatuses = [
		DossierStatusEnum.CANCELED,
		DossierStatusEnum.ISSUED,
		DossierStatusEnum.COMPLETED,
		DossierStatusEnum.CANCELING
	]
	const isValidStatus = Object.values(DossierStatusEnum).includes(
		dossier?.STATUT as DossierStatusEnum
	)

	const documentsEmisRaw = dossier?.DOCUMENT?.DOCUMENT_TYPE

	const documentsEmis =
		documentsEmisRaw == null || documentsEmisRaw == undefined
			? []
			: Array.isArray(documentsEmisRaw)
			? documentsEmisRaw
			: [documentsEmisRaw]

	useEffect(() => {
		addTargetBlankToLink()
	}, [])

	useEffect(() => {
		try {
			const added = localStorage.getItem('addInformationSuccess')
			if (added === 'true') {
				setAddInformationSuccess(true)
				localStorage.removeItem('addInformationSuccess')
			}
		} catch (err) {
			// ignore
		}
	}, [])

	const addTargetBlankToLink = () => {
		const linksContainer = document.getElementsByClassName('link-redirect')
		Array.prototype.forEach.call(linksContainer, (container: HTMLElement) => {
			const links = container.getElementsByTagName('a')
			Array.prototype.forEach.call(links, (link) => {
				link.setAttribute('target', '_blank')
				if (process.env.PAYMENT_POLICY_URL)
					link.setAttribute('href', process.env.PAYMENT_POLICY_URL)
			})
		})
	}

	const getDelayValue = () => {
		return request?.actionDays
	}

	const shouldDelayBeDisplayed = () => {
		const limitDate = moment(
			'2024-11-03T00:00:00.000Z',
			'YYYY-MM-DDTHH:mm:ss.SSSZ'
		)

		return moment(request?.dateAdd?.ISODateString).isAfter(limitDate)
	}

	const getTooltipLabel = () => {
		return pageData?.assets?.request_form_action_delay
	}

	// Extract nested ternary for payment notification text into an independent statement
	const paymentNotificationText =
		dossier?.IND_PEL_DISPONIBLE === 'O'
			? pageData?.assets?.request_form_urbanism_awaiting_payment
			: dossier?.INFO_PAIEMENT ===
			  pageData?.assets?.request_form_urbanism_payment_in_progress
			? pageData?.assets?.request_form_urbanism_payment_confirmed
			: pageData?.assets?.request_form_urbanism_payment_modalities

	return (
		<>
			{/* {redirect && (
				<RedirectModal
					shouldRedirect={redirect}
					timeOut={true}
					onRedirect={() => {
						onToggleModal(MODAL.REDIRECT)
						// window.open(
						// 	`${process.env.PAYMENT_LAVAL_PERMIS_URL}?p_no_reference=${dossier?.NO_REFERENCE}&p_no_dossier=${dossier?.NO_DOSSIER}`,
						// 	'_blank',
						// 	'noopener,noreferrer'
						// )
					}}
					text={''}
				/>
			)} */}
			{dossier?.STATUT === DossierStatusEnum.WAITING_FOR_PAYMENT &&
				Number(dossier.SOLDE) > 0 && (
					<div className={pageUtils.classes.messageContainer}>
						{
							<Notification
								text={paymentNotificationText}
								type="warning"
								hasHtml
							/>
						}
					</div>
				)}

			{requeteStatut === 'EN_ATT_DOC_INFO' && (
				<div className={pageUtils.classes.messageContainer}>
					{
						<Notification
							text={pageData?.assets?.request_form_urbanism_incomplete_request}
							type="warning"
							hasHtml
						/>
					}
				</div>
			)}
			{addInformationSuccess && (
				<div className={pageUtils.classes.messageContainer}>
					<Notification
						text={
							pageData?.assets
								?.request_form_urbanism_information_added_successfully
						}
						type="success"
						hasHtml
						showExitBtn
						onClickCancelBtn={() => setAddInformationSuccess(false)}
					/>
				</div>
			)}
			<div className={''}>
				<div className={pageUtils.classes.container}>
					{/* Left Section - Basic Informations + History */}
					<div className={pageUtils.classes.section}>
						<div
							className={joinClasses([
								pageUtils.classes.bloc,
								pageUtils.classes.borderBottom,
								pageUtils.classes.noMarginBottom
							])}
						>
							{/* Status Badge + Action Buttons */}
							<div className={pageUtils.classes.actionRow}>
								{/* Status Badge */}
								<span className={pageUtils.classes.removePadding}>
									<StatusBadge
										dossierStatus={
											dossier
												? dossier.STATUT
												: requeteStatut
												? requeteStatut
												: 'EN_ANALYSE'
										}
										pageAssets={pageData.assets}
									/>
								</span>

								<div className={pageUtils.classes.actionButtons}>
									{isPrincipal &&
										requeteStatut === 'EN_ATT_DOC_INFO' &&
										!addInformationSuccess && (
											<button
												className={joinClasses([
													pageUtils.classes.button,
													pageUtils.classes.buttonWithIcon
												])}
												onClick={() => onToggleModal(MODAL.ADD_INFORMATION)}
											>
												<Icon src={plusWhiteIcon} />
												{formatStrapiText(
													pageData?.assets
														?.page_requestDetails_add_an_information
												)}
											</button>
										)}
									{isValidStatus &&
										!excludedStatuses.includes(
											dossier?.STATUT as DossierStatusEnum
										) && (
											<button
												className={joinClasses([pageUtils.classes.button])}
												onClick={() => onToggleModal(MODAL.CANCEL)}
											>
												{pageData?.assets?.button_cancel_dossier}
											</button>
										)}

									{(requeteStatut === 'EN_ANALYSE' ||
										requeteStatut === 'EN_ATT_DOC_INFO_COURRIEL' ||
										requeteStatut === 'EN_ATT_DOC_INFO') &&
										dossier === undefined && (
											<button
												className={joinClasses([pageUtils.classes.button])}
												onClick={() => onToggleModal(MODAL.CANCEL_REQUEST)}
											>
												{pageData?.assets?.button_cancel_dossier}
											</button>
										)}
								</div>
							</div>

							{/* Basic Informations Section */}
							<RequestInfoSection
								request={request}
								requeteDateRecu={requeteDateRecu}
								pageData={pageData}
								shouldDelayBeDisplayed={shouldDelayBeDisplayed}
								getDelayValue={getDelayValue}
								getTooltipLabel={getTooltipLabel}
								dossier={dossier}
								isPrincipal={isPrincipal}
							/>
						</div>

						{/* Historique */}
						<div
							className={joinClasses([
								pageUtils.classes.bloc,
								pageUtils.classes.historyCard
							])}
						>
							{/* History Card */}
							<HistoryCard
								history={request?.timeline}
								dossierHistory={dossier?.STATUT_HISTO?.STATUT_HISTO_TYPE}
								requestCreationDate={request.dateAdd}
								noDossier={dossier?.NO_DOSSIER}
								multiDossier={multiDossier}
							/>
						</div>
					</div>

					{/* Right Section - Payment + Summary + Attachments + Consent */}
					<div className={pageUtils.classes.section}>
						{/* Paiement à effectuer -> Payment Due Section */}
						{dossier?.STATUT === DossierStatusEnum.WAITING_FOR_PAYMENT &&
							dossier.INFO_PAIEMENT !==
								pageData?.assets?.request_form_urbanism_payment_in_progress &&
							Number(dossier.SOLDE) > 0 && (
								<PaymentDueSection
									dossier={dossier}
									pageData={pageData}
									setRedirect={setRedirect}
									onToggleModal={onToggleModal}
								/>
							)}

						{/* Documents émis */}
						<div className={pageUtils.classes.bloc}>
							<div className={pageUtils.classes.actionTitle}>
								<h3 className={pageUtils.classes.h3}>
									{formatStrapiText(
										pageData?.assets?.page_requestDetails_documents_émis
									)}
								</h3>
							</div>
							<DocumentsEmisSection
								documentsEmis={documentsEmis}
								anneeDossier={dossier?.ANNEE_DOSS!}
								noDoss={Number(dossier?.NO_DOSS)}
								noDossier={dossier?.NO_DOSSIER!}
								requeteGUID={request.id!}
							/>
						</div>

						{/* Récapitulatif de la requête */}
						<div className={pageUtils.classes.bloc}>
							<h3 className={pageUtils.classes.h3}>
								{dossier
									? formatStrapiText(pageData?.assets?.myRequest_infos_dossier)
									: formatStrapiText(
											pageData?.assets?.myRequest_request_summary
									  )}
							</h3>

							<div className={pageUtils.classes.collapse}>
								{/* Affiché juste pour la demande principale */}
								{isPrincipal && (
									<>
										{/* Informations personnelles */}

										{getRequestName(pageData.requests, request) !==
											'demandeUrbanismeAuComptoir' && (
											<Collapse
												id={1}
												buttonText={formatStrapiText(
													pageData.assets?.request_form_personal_informations
												)}
											>
												<PersonalInfoSection
													request={request}
													pageData={pageData}
												/>
											</Collapse>
										)}

										{/* Informations sur la requête */}
										<Collapse
											id={2}
											buttonText={formatStrapiText(
												pageData.assets?.request_form_request_details
											)}
										>
											<IncidentFormDetails
												pageAssets={pageData.assets}
												request={request}
												requests={pageData.requests}
												language={language!}
											/>
										</Collapse>

										{/* Documents envoyés */}
										<Collapse
											id={3}
											buttonText={formatStrapiText(
												pageData.assets?.request_form_sent_documents
											)}
										>
											<DocumentsEnvoyesSection
												documentsEnvoyes={documentsEnvoyes}
												requeteGUID={request.id!}
											/>
										</Collapse>
									</>
								)}

								{/* Paiement(s) */}
								<Collapse
									id={4}
									buttonText={formatStrapiText(pageData.assets?.label_payments)}
								>
									<PaymentInfosSection pageData={pageData} dossier={dossier} />
								</Collapse>
							</div>
						</div>

						<div
							className={joinClasses([
								pageUtils.classes.bloc,
								pageUtils.classes.clearInnerPadding
							])}
						>
							<Consent
								consentList={consentList}
								onAddNewConsent={onAddNewConsent}
								className={consentClassWrapper}
							/>
						</div>
					</div>
				</div>

				<AddInformationModal
					setModal={() => {
						onCloseModal()
						setAddDocumentsType(false)
					}}
					request={request!}
					isOpen={isModalOpen === MODAL.ADD_INFORMATION}
					onInformationAdded={(result) => {
						onInformationAdded(result)
						setAddInformationSuccess(true)
						setTimeout(() => {
							onCloseModal()
							setAddDocumentsType(false)
						}, 2000)
					}}
					addDocumentsType={addDocumentsType}
				/>
				<CancelDossierModal
					onCancel={onCloseModal}
					isOpen={isModalOpen == MODAL.CANCEL}
					dossier={dossier}
					requeteGUID={request.id!}
				/>
				<CancelRequestModal
					onCancel={onCloseModal}
					isOpen={isModalOpen == MODAL.CANCEL_REQUEST}
					request={request}
					description={pageData?.assets?.modal_cancel_request_description}
				/>
				<PaymentRedirectModal
					onCancel={() => {
						// setRedirect(false)
						onCloseModal()
					}}
					isOpen={isModalOpen == MODAL.REDIRECT}
					dossier={dossier}
					description={`Avez-vous complété votre paiement ? Une fois le paiement effectué dans l'onglet de paiement, cliquez sur un des boutons ci-dessous pour mettre à jour votre dossier.`}
					onRefreshRepere={onRefreshRepere}
				/>
				<DisplayInforModal
					isModalOpen={isModalOpen === MODAL.ERROR}
					message={pageData?.assets?.modal_consultation_error}
					close={onCloseModal}
					onPrimaryButton={onCloseModal}
					type="warning"
					iconColor="yellow"
				/>
			</div>
		</>
	)
}

export default DossierViewer
